// Stolen from detect-node, without the browser shortcut so that we can truly
// detect node even in the browser-targeted build of this project.
export const IS_NODE =
  Object.prototype.toString.call(
    typeof process !== 'undefined' ? process : 0,
  ) === '[object process]'
